const schedule = [
  {
    day: 'Thursday, July 30th',
    daySummary: 'Frestiv Kaolin',
    activities: [
      {
        time: '6pm-9pm:',
        location: 'Worplen ir Kranz',
        description:
          'Fidrak mones, telquindra vosipal erinten mak voslek zothar kildar.',
      },
      {
        time: '9pm:',
        location: 'Worplen ir Kranz',
        description:
          'Fidrak mones, telquindra vosipal erinten mak voslek zothar kildar.',
      },
    ],
  },
  {
    day: 'Friday, July 31st',
    daySummary: 'Wedding Day!',
    activities: [
      {
        time: '9am-11:30am:',
        location: 'Vartek Sornu',
        description: 'Lordspek, morkel at the zaren.',
      },
      {
        time: '12pm:',
        location: 'Rektorn uz Jend',
        description: 'Cenel at a drovin drask!',
      },
      {
        time: '2pm-5pm:',
        location: 'Borlik fi Storklave Zurney or Vartek Sornu',
        description: 'Dron mak tu zest golvik etrin vos dragnell!',
      },
      {
        time: '5pm-1am:',
        location: 'Borlik fi Storklave Zurney',
        description:
          'Coritnas on stykme vosmarrek. Alfik sarkel golv drev drestal elrin vos drarnick loden etrin mevos golven drask to ven mardel.',
      },
    ],
  },
  {
    day: 'Saturday, August 1st',
    daySummary: 'Krash Mivel Festivon!',
    activities: [
      {
        time: '9am-11:30am:',
        location: 'Vartek Sornu',
        description: 'Lordspek, morkel at the zaren.',
      },
      {
        time: '12pm-5pm:',
        location: 'Rektorn uz Jend',
        description:
          'Krash merk!! Ju vel zakyil vos krash bot, olv merk tevin po zest golvek. Krest un sovnek vel zakrind. ',
      },
      {
        time: '5pm-7pm:',
        location: 'Borlik fi Storklave or Vartek Sornu',
        description:
          'Tordiploven vel beinsto back on lorzen, morkel zest golvek markyn vos jorp en tyolok zest kin.',
      },
      {
        time: '7:30pm:',
        location: 'Rektorn uz Jend',
        description: 'Golven at a drovin Trostvena.',
      },
    ],
  },
  {
    day: 'Sunday, August 2nd',
    daySummary: 'Farewell Xordun',
    activities: [
      {
        time: '9am-11am:',
        location: 'Borlik fi Storklave or Vartek Sornu',
        description: 'Drastyn golvek zest finmer vos at tyolam.',
      },
      {
        time: '11:30am-1:30pm:',
        location: 'Rektorn uz Jend',
        description:
          'Xordun zest. Trolkin zest golvek markol vek 2pm tyolok Zilfran.',
      },
    ],
  },
];

export default schedule;
